<app-mobile-page-shell [hideBottomNav]="true">

  <!-- ===== BOM VIEW ===== -->
  <ng-container *ngIf="activeView === 'bom'">

    <app-mobile-metric-ribbon [metrics]="bomRibbonMetrics"></app-mobile-metric-ribbon>

    <!-- Section header -->
    <div class="m-section m-section--bom">
      <div class="m-section-header">
        <div class="m-section-icon"><i class="bi bi-list-ul"></i></div>
        <div class="m-section-header-text">
          <h6 class="m-section-title mb-0">Bill of Materials</h6>
        </div>
        <button class="btn btn-outline-primary btn-sm ms-auto" (click)="openAddBom()">
          <i class="bi bi-plus-lg me-1"></i>Add
        </button>
      </div>
      <div class="m-filter-row m-filter-row--inset">
        <button class="m-filter-pill" [class.m-filter-pill--active]="bomFilter === 'active'"
          (click)="onBomFilterChange('active')">Active</button>
        <button class="m-filter-pill" [class.m-filter-pill--active]="bomFilter === 'inactive'"
          (click)="onBomFilterChange('inactive')">Inactive</button>
        <button class="m-filter-pill" [class.m-filter-pill--active]="bomFilter === 'all'"
          (click)="onBomFilterChange('all')">All</button>
      </div>
    </div>

    <!-- BOM cards -->
    <div class="m-cards-section">
      <div *ngIf="filteredBoms.length === 0" class="m-empty">
        <i class="bi bi-clipboard-x"></i>
        <p>No BOMs found</p>
      </div>

      <app-mobile-data-card
        *ngFor="let bom of filteredBomsPaged; let i = index"
        [expandable]="true"
        [title]="getProductName(bom.finishedGoodItemID) || ('BOM ' + bom.bomHeaderID)"
        [fields]="bomCardFields(bom)"
        [animationDelay]="i * 50"
        [fullItem]="bom"
        (editTap)="openEditBom($event)">
        <div class="m-bom-components">
          <div *ngIf="!bom.components?.length" class="m-bom-comp-empty">No components</div>
          <div class="m-bom-comp-row" *ngFor="let c of bom.components">
            <span class="m-bom-comp-name">{{ rawMaterialName(c.rawMaterialItemID) }}</span>
            <span class="m-bom-comp-qty">{{ c.quantityRequired }} {{ componentUomCode(c) }}</span>
          </div>
        </div>
      </app-mobile-data-card>

      <div *ngIf="filteredBomsTotalPages > 1" class="inv-pagination">
        <button class="inv-page-btn" [disabled]="bomsCurrentPage === 1" (click)="changeBomsPage(bomsCurrentPage - 1)">
          <i class="bi bi-chevron-left"></i>
        </button>
        <span class="inv-page-info">{{ bomsCurrentPage }} / {{ filteredBomsTotalPages }}</span>
        <button class="inv-page-btn" [disabled]="bomsCurrentPage === filteredBomsTotalPages" (click)="changeBomsPage(bomsCurrentPage + 1)">
          <i class="bi bi-chevron-right"></i>
        </button>
      </div>
    </div>

  </ng-container>

  <!-- ===== ORDERS VIEW ===== -->
  <ng-container *ngIf="activeView === 'orders'">

    <app-mobile-metric-ribbon [metrics]="orderRibbonMetrics"></app-mobile-metric-ribbon>

    <!-- Section header -->
    <div class="m-section m-section--orders">
      <div class="m-section-header">
        <div class="m-section-icon"><i class="bi bi-box"></i></div>
        <div class="m-section-header-text">
          <h6 class="m-section-title mb-0">Orders</h6>
        </div>
        <button class="btn btn-outline-primary btn-sm ms-auto" (click)="openAddOrder()">
          <i class="bi bi-plus-lg me-1"></i>Add
        </button>
      </div>
      <div class="m-filter-row m-filter-row--inset">
        <button class="m-filter-pill" [class.m-filter-pill--active]="showCompletedOrders"
          (click)="toggleShowCompletedOrders()">
          <i class="bi me-1" [class.bi-eye]="!showCompletedOrders" [class.bi-eye-slash]="showCompletedOrders"></i>
          {{ showCompletedOrders ? 'Hide Completed' : 'Show Completed' }}
        </button>
      </div>
    </div>

    <!-- Order cards -->
    <div class="m-cards-section">
      <div *ngIf="filteredOrders.length === 0" class="m-empty">
        <i class="bi bi-cart-x"></i>
        <p>No production orders</p>
      </div>

      <div *ngFor="let order of filteredOrdersPaged; let i = index; trackBy: trackByOrderId" class="m-order-card" [style.animation-delay]="i * 50 + 'ms'">
        <div class="m-order-header">
          <div>
            <div class="m-order-title">{{ getProductName(order.finishedGoodItemID) }}</div>
            <div class="m-order-ref">{{ order.orderNumber }}</div>
          </div>
        </div>
        <div class="m-order-chips">
          <span class="m-chip">Qty: {{ order.quantityToProduce }}</span>
          <span class="m-chip" *ngIf="order.plannedEndDate">Due: {{ order.plannedEndDate | date:'d MMM y' }}</span>
        </div>
        <!-- Inline status select -->
        <div class="m-order-status-row">
          <div class="m-status-dropdown-wrap" [ngClass]="'status-' + sanitizeStatus(order.status)">
            <app-single-select-dropdown
              [options]="statusOptions(order)"
              [selectedValue]="order.status"
              (selectedValueChange)="onStatusSelectChange(order, $event)">
            </app-single-select-dropdown>
          </div>
        </div>
      </div>

      <div *ngIf="filteredOrdersTotalPages > 1" class="inv-pagination">
        <button class="inv-page-btn" [disabled]="ordersCurrentPage === 1" (click)="changeOrdersPage(ordersCurrentPage - 1)">
          <i class="bi bi-chevron-left"></i>
        </button>
        <span class="inv-page-info">{{ ordersCurrentPage }} / {{ filteredOrdersTotalPages }}</span>
        <button class="inv-page-btn" [disabled]="ordersCurrentPage === filteredOrdersTotalPages" (click)="changeOrdersPage(ordersCurrentPage + 1)">
          <i class="bi bi-chevron-right"></i>
        </button>
      </div>
    </div>

  </ng-container>

  <!-- ===== WORKFLOW VIEW ===== -->
  <ng-container *ngIf="activeView === 'workflow'">

    <!-- Active category heading card -->
    <div class="m-section m-section--workflow">
      <div class="m-section-header">
        <div class="m-section-icon">
          <i class="bi" [ngClass]="activeWorkflowStatusIcon"></i>
        </div>
        <div class="m-section-header-text">
          <h6 class="m-section-title mb-0">{{ activeWorkflowStatus }}</h6>
        </div>
        <span class="m-status-badge ms-auto">{{ getStatusOrders(activeWorkflowStatus).length }}</span>
      </div>
    </div>

    <!-- Orders for active status -->
    <div class="m-workflow-list">
      <div *ngIf="getStatusOrders(activeWorkflowStatus).length === 0" class="m-empty">
        <i class="bi bi-inbox"></i>
        <p>No orders</p>
      </div>

      <div *ngFor="let order of workflowOrdersPaged" class="m-workflow-card-wrap">
        <!-- Swipe hint layer -->
        <div class="m-workflow-swipe-hint"
          [class.m-workflow-swipe-hint--next]="swipeHintSide(order) === 'next'"
          [class.m-workflow-swipe-hint--prev]="swipeHintSide(order) === 'prev'">
          <ng-container *ngIf="swipeHintSide(order) === 'next'">
            <i class="bi bi-arrow-right-circle-fill me-2"></i>{{ nextStatus(order) }}
          </ng-container>
          <ng-container *ngIf="swipeHintSide(order) === 'prev'">
            {{ previousStatus(order) }}<i class="bi bi-arrow-left-circle-fill ms-2"></i>
          </ng-container>
        </div>

        <!-- Card -->
        <div class="m-workflow-card"
          [style.transform]="swipeTranslate(order)"
          [class.m-workflow-card--swiping]="swipeOrderId === order.productionOrderID"
          (touchstart)="onCardSwipeStart(order, $event)"
          (touchmove)="onCardSwipeMove(order, $event)"
          (touchend)="onCardSwipeEnd(order)"
          (touchcancel)="onCardSwipeEnd(order)">
          <div class="m-workflow-card-body">
            <div class="m-workflow-card-title">{{ getProductName(order.finishedGoodItemID) }}</div>
            <div class="m-workflow-card-meta">
              <span>{{ order.orderNumber }}</span>
              <span>Qty: {{ order.quantityToProduce }}</span>
            </div>

            <!-- Progress bar -->
            <div class="m-progress-wrap">
              <div class="m-progress">
                <div class="m-progress-bar" [style.width]="(order.completionPercentage || 0) + '%'">
                  {{ order.completionPercentage || 0 }}%
                </div>
                <input type="range" class="m-progress-range" min="0" max="100"
                  [(ngModel)]="order.completionPercentage"
                  (change)="onProgressChange($event, order)"
                  (pointerdown)="$event.stopPropagation()"
                  (pointerup)="$event.stopPropagation()"
                  (pointercancel)="$event.stopPropagation()"
                  (mousedown)="$event.stopPropagation()"
                  (mouseup)="$event.stopPropagation()"
                  (touchstart)="$event.stopPropagation()"
                  (touchend)="$event.stopPropagation()"
                  (touchcancel)="$event.stopPropagation()" />
                <div class="m-progress-thumb" [style.left]="(order.completionPercentage || 0) + '%'"></div>
              </div>
            </div>

            <!-- Date row -->
            <div class="m-workflow-date" *ngIf="order.createdAt">
              <i class="bi bi-clock me-1"></i>{{ order.createdAt | date:'d MMM yyyy' }}
            </div>

            <div class="m-workflow-hint"><i class="bi bi-hand-index-thumb me-1"></i>Swipe or tap button to change status</div>
          </div>
          <button type="button" class="m-workflow-status-btn"
            (touchstart)="$event.stopPropagation()"
            (touchmove)="$event.stopPropagation()"
            (touchend)="onStatusBtnTouch(order, $event)">
            <i class="bi bi-arrow-left-right"></i>
          </button>
        </div>
      </div>
    </div>

    <div *ngIf="workflowOrdersTotalPages > 1" class="inv-pagination">
      <button class="inv-page-btn" [disabled]="workflowCurrentPage === 1" (click)="changeWorkflowPage(workflowCurrentPage - 1)">
        <i class="bi bi-chevron-left"></i>
      </button>
      <span class="inv-page-info">{{ workflowCurrentPage }} / {{ workflowOrdersTotalPages }}</span>
      <button class="inv-page-btn" [disabled]="workflowCurrentPage === workflowOrdersTotalPages" (click)="changeWorkflowPage(workflowCurrentPage + 1)">
        <i class="bi bi-chevron-right"></i>
      </button>
    </div>

    <!-- Category tabs pinned to bottom -->
    <app-mobile-category-tabs
      [tabs]="workflowCategoryTabs"
      [activeKey]="activeWorkflowStatus"
      (tabChange)="selectWorkflowStatus($event)">
    </app-mobile-category-tabs>

  </ng-container>

  <!-- ===== PRODUCTS VIEW ===== -->
  <ng-container *ngIf="activeView === 'products'">

    <!-- Section header -->
    <div class="m-section m-section--products">
      <div class="m-section-header">
        <span class="m-section-icon"><i class="bi bi-box-seam"></i></span>
        <span class="m-section-header-text">
          <span class="m-section-title">Products</span>
        </span>
        <div class="m-filter-row--inset ms-auto">
          <button class="m-filter-pill" [class.m-filter-pill--active]="showSoldOrders"
            (click)="toggleShowSoldOrders.emit()">
            <i class="bi me-1" [class.bi-eye]="!showSoldOrders" [class.bi-eye-slash]="showSoldOrders"></i>
            {{ showSoldOrders ? 'Hide Sold' : 'Show Sold' }}
          </button>
        </div>
      </div>
    </div>

    <!-- Product order cards -->
    <ng-container>
    <div class="m-cards-section">
      <div *ngIf="completedFactoryOrders.length === 0" class="m-empty">
        <i class="bi bi-box-seam"></i>
        <p>No completed orders yet</p>
      </div>

      <div *ngFor="let order of completedFactoryOrdersPaged; let i = index; trackBy: trackByOrderId"
           class="m-order-card" [style.animation-delay]="i * 50 + 'ms'">
        <div class="m-order-header">
          <div>
            <div class="m-order-title">{{ getProductName(order.finishedGoodItemID) }}</div>
            <div class="m-order-ref">{{ order.orderNumber }}</div>
          </div>
          <span class="m-prod-status-badge" [ngClass]="'prod-status-' + sanitizeStatus(order.status)">
            {{ order.status === 'Partially Sold' ? 'Completed' : order.status }}
          </span>
        </div>

        <div class="m-order-chips">
          <span class="m-chip">Produced: {{ order.quantityToProduce }}</span>
          <span class="m-chip">Sold: {{ order.quantityConsumed || 0 }}</span>
          <span class="m-chip" *ngIf="order.createdAt">Created: {{ order.createdAt | date:'d MMM y' }}</span>
          <span class="m-chip" *ngIf="order.actualEndDate">Completed: {{ order.actualEndDate | date:'d MMM y' }}</span>
        </div>

        <!-- Sell controls (only for Completed / Partially Sold) -->
        <div class="m-sell-row" *ngIf="order.status !== 'Sold'">
          <input type="number" class="form-control m-sell-input"
                 [min]="1"
                 [max]="order.quantityToProduce - (order.quantityConsumed || 0)"
                 [(ngModel)]="sellQtyMap[order.productionOrderID]"
                 placeholder="Qty">
          <button class="m-sell-btn"
                  [disabled]="!sellQtyMap[order.productionOrderID]"
                  (click)="sellOrder.emit({ order: order, qty: sellQtyMap[order.productionOrderID] })">
            Sell
          </button>
          <button class="m-sell-btn m-sell-btn--all"
                  (click)="sellOrder.emit({ order: order, qty: order.quantityToProduce - (order.quantityConsumed || 0) })">
            All
          </button>
        </div>
      </div>

      <div *ngIf="completedFactoryOrdersTotalPages > 1" class="inv-pagination">
        <button class="inv-page-btn" [disabled]="productsCurrentPage === 1" (click)="changeProductsPage(productsCurrentPage - 1)">
          <i class="bi bi-chevron-left"></i>
        </button>
        <span class="inv-page-info">{{ productsCurrentPage }} / {{ completedFactoryOrdersTotalPages }}</span>
        <button class="inv-page-btn" [disabled]="productsCurrentPage === completedFactoryOrdersTotalPages" (click)="changeProductsPage(productsCurrentPage + 1)">
          <i class="bi bi-chevron-right"></i>
        </button>
      </div>
    </div>

    </ng-container>
  </ng-container>

</app-mobile-page-shell>


<!-- ===== BOM Offcanvas ===== -->
<app-bom-item-offcanvas
  [visible]="bomOffcanvasVisible"
  [bom]="bomOffcanvasItem"
  [isEditing]="bomOffcanvasEditing"
  [products]="products"
  [rawMaterials]="rawMaterials"
  [uoms]="uoms"
  (closeCanvas)="onBomOffcanvasClose()"
  (save)="onBomSave($event)">
</app-bom-item-offcanvas>

<!-- ===== Factory Order Offcanvas ===== -->
<app-factory-order-offcanvas
  [visible]="orderOffcanvasVisible"
  [order]="orderOffcanvasItem"
  [isEditing]="false"
  [products]="productsWithBOMs"
  (closeCanvas)="onOrderOffcanvasClose()"
  (save)="onOrderSave($event)">
</app-factory-order-offcanvas>

<!-- ===== Workflow Status Picker ===== -->
<div class="m-del-overlay" *ngIf="statusPickerVisible"
  (click)="$event.target === $event.currentTarget && closeStatusPicker()">
  <div class="m-del-sheet" (click)="$event.stopPropagation()"
    [style.transform]="statusPickerIsClosing ? 'translateY(100%)' : 'translateY(' + statusPickerSwipeDeltaY + 'px)'"
    [style.transition]="statusPickerSwipeActive ? 'none' : statusPickerIsClosing ? 'transform 0.28s cubic-bezier(0.4,0,1,1)' : ''"
    [style.opacity]="1 - statusPickerSwipeProgress * 0.3">
    <div class="m-del-handle-bar"
      (touchstart)="onStatusPickerTouchStart($event)"
      (touchmove)="onStatusPickerTouchMove($event)"
      (touchend)="onStatusPickerTouchEnd()">
      <div class="m-del-handle"
        [style.width]="(36 + statusPickerSwipeProgress * 20) + 'px'"
        [style.background]="statusPickerSwipeProgress > 0 ? '#0d9488' : '#ccc'"></div>
    </div>
    <div class="m-del-header">
      <h5 class="m-del-title">Change Status</h5>
      <button class="m-del-close-btn" (click)="closeStatusPicker()" (touchend)="$event.preventDefault(); closeStatusPicker()"><i class="bi bi-x-lg"></i></button>
    </div>
    <div class="m-status-picker-body">
      <button *ngFor="let s of workflowStatuses(statusPickerOrder)"
        class="m-status-pick-btn"
        [class.active]="statusPickerOrder?.status === s"
        (click)="pickStatus(s)"
        (touchend)="pickStatusTouch(s, $event)">
        <span class="m-status-dot" [ngClass]="'dot-' + sanitizeStatus(s)"></span>
        {{ s }}
      </button>
    </div>
  </div>
</div>
